import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Menu from './components/Menu';
import TrainingFilter from './components/TrainingFilter';
import Accordion from './components/Accordion';
import HeroImageAnimation from './components/HeroImageAnimation';
import TrainingFilterSlideIn from './components/TrainingFilterSlideIn';
import ResponsiveVideo from './components/ResponsiveVideo';
import VideoPlayer from './components/VideoPlayer';
import AOS from 'aos';
import { SubscribeForm } from './components/SubscribeForm';
import NewsFilter from './components/NewsFilter';

export class Alfred {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Alfred.domReady()]).then(() => this.init());
	}

	init() {
		document.dispatchEvent(new Event('bless'));

		new Menu();
		new Accordion();
		ResponsiveVideo.init();
		VideoPlayer.init();
		AOS.init();
		new SubscribeForm();
		new HeroImageAnimation();

		const $filterMenu = document.querySelector('[data-filter-menu]');
		if ($filterMenu) {
			new TrainingFilterSlideIn();
		}

		const $trainingfilter = document.querySelector('[data-trainingfilter] form');
		if ($trainingfilter) {
			new TrainingFilter($trainingfilter);
		}

		const $newsfilter = document.querySelector('[data-newsfilter]');
		if ($newsfilter) {
			new NewsFilter($newsfilter);
		}
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Alfred();

// jQuery document ready:

// (function($) {
// 	$('body').trigger('bless');
// })(jQuery);
